import React, { useState, useEffect } from 'react';

const CreateLandmarkModal = ({ isOpen, onClose, onSave, project }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    location: '',
    completionDate: new Date().toISOString().slice(0, 10),
    images: [],
  });

  useEffect(() => {
    if (project) {
      setFormData({
        title: project.title,
        description: project.description,
        location: project.location,
        completionDate: new Date(project.completionDate).toISOString().slice(0, 10),
        images: [],
      });
    } else {
      setFormData({
        title: '',
        description: '',
        location: '',
        completionDate: new Date().toISOString().slice(0, 10),
        images: [],
      });
    }
  }, [project]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, images: [...e.target.files] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl w-full max-h-[90vh] flex flex-col">
        <h2 className="text-2xl font-bold text-[#364A9A] mb-6 font-poppins">{project ? 'Edit' : 'Create'} Landmark Project</h2>
        <form onSubmit={handleSubmit} className="space-y-4 overflow-y-auto">
          <div>
            <label htmlFor="title" className="block text-gray-700 font-bold mb-2">Title</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              required
            />
          </div>
          <div>
            <label htmlFor="description" className="block text-gray-700 font-bold mb-2">Description</label>
            <textarea
              id="description"
              name="description"
              rows="5"
              value={formData.description}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              
            ></textarea>
          </div>
          <div>
            <label htmlFor="location" className="block text-gray-700 font-bold mb-2">Location</label>
            <input
              type="text"
              id="location"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              
            />
          </div>
          <div>
            <label htmlFor="completionDate" className="block text-gray-700 font-bold mb-2">Completion Date</label>
            <input
              type="date"
              id="completionDate"
              name="completionDate"
              value={formData.completionDate}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#364A9A]"
              required
            />
          </div>
          <div>
            <label htmlFor="images" className="block text-gray-700 font-bold mb-2">Images</label>
            <input
              type="file"
              id="images"
              name="images"
              onChange={handleFileChange}
              multiple
              className="w-full"
            />
          </div>
          <div className="text-right mt-6">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white font-bold py-2 px-4 rounded-lg mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateLandmarkModal;